import { createContext } from 'utils/react-helpers';

const [PreLoadProvider, usePreLoad] = createContext('PreLoadContext');

export { PreLoadProvider, usePreLoad };
